import theme from '@/utils/themes/Themes.module.scss';
import mcc from '@/components/MainContainer/MainContainerComponents.module.scss';
import React, { useEffect, useState } from 'react';

import { Button, Flex, Input, Typography, Form, Modal } from 'antd';
import { IModalProps } from 'tkmp-lib/src/interfaces';
import useLocalization from 'tkmp-lib/src/hooks/useLocalization';

const LOCATION_COLUMNS = 4;

const citiesList = {
    all: [
        { key: 1, label: 'Астрахань', alias: 'astrahan' },
        { key: 2, label: 'Архангельск', alias: 'arkhangelsk' },
        { key: 3, label: 'Барнаул', alias: 'barnau' },
        { key: 4, label: 'Брянск', alias: 'bryansk' },
        { key: 5, label: 'Белгород', alias: 'belgorod' },
        { key: 6, label: 'Волгоград', alias: 'volgograd' },
        { key: 7, label: 'Воронеж', alias: 'voronezh' },
        { key: 8, label: 'Владивосток', alias: 'vladivostok' },
        { key: 9, label: 'Владикавказ', alias: 'vladikavkaz' },
        { key: 10, label: 'Владимир', alias: 'vladimir' },
        { key: 11, label: 'Волжский', alias: 'volzhsky' },
        { key: 12, label: 'Вологда', alias: 'vologda' },
        { key: 13, label: 'Екатеринбург', alias: 'yekaterinburg' },
        { key: 14, label: 'Иваново', alias: 'ivanovo' },
        { key: 15, label: 'Ивантеевка', alias: 'ivanteyevka' },
        { key: 16, label: 'Казань', alias: 'kazan' },
        { key: 17, label: 'Калининград', alias: 'kaliningrad' },
        { key: 18, label: 'Калуга', alias: 'kaluga' },
        { key: 19, label: 'Красноярск', alias: 'krasnoyarsk' },
        { key: 20, label: 'Кемерово', alias: 'kemerovo' },
        { key: 21, label: 'Киров', alias: 'kirov' },
        { key: 22, label: 'Краснодар', alias: 'krasnodar' },
        { key: 23, label: 'Курган', alias: 'kurgan' },
        { key: 24, label: 'Курск', alias: 'kursk' },
        { key: 25, label: 'Липецк', alias: 'lipeck' },
        { key: 26, label: 'Магнитогорск', alias: 'magnitogorsk' },
        { key: 27, label: 'Махачкала', alias: 'makhachkala' },
        { key: 28, label: 'Москва', alias: 'moscow' },
        { key: 29, label: 'Мурманск', alias: 'murmansk' },
        { key: 30, label: 'Набережные Челны', alias: 'naberezhnye_chelny' },
        { key: 31, label: 'Нижний Новгород', alias: 'nizhny_novgorod' },
        { key: 32, label: 'Омск', alias: 'omsk' },
        { key: 33, label: 'Орел', alias: 'orel' },
        { key: 34, label: 'Оренбург', alias: 'orenburg' },
        { key: 35, label: 'Пенза', alias: 'penza' },
        { key: 36, label: 'Пермь', alias: 'perm' },
        { key: 37, label: 'Ростов-на-Дону', alias: 'rostov_na_donu' },
        { key: 38, label: 'Рязань', alias: 'ryazan' },
        { key: 39, label: 'Санкт-Петербург', alias: 'sankt_peterburg' },
        { key: 40, label: 'Самара', alias: 'samara' },
        { key: 41, label: 'Саранск', alias: 'saransk' },
        { key: 42, label: 'Саратов', alias: 'saratov' },
        { key: 43, label: 'Симферополь', alias: 'simferopol' },
        { key: 44, label: 'Смоленск', alias: 'smolensk' },
        { key: 45, label: 'Сочи', alias: 'sochi' },
        { key: 46, label: 'Ставрополь', alias: 'stavropol' },
        { key: 47, label: 'Сургут', alias: 'surgut' },
        { key: 48, label: 'Тверь', alias: 'tver' },
        { key: 49, label: 'Тольятти', alias: 'tolyatti' },
        { key: 50, label: 'Томск', alias: 'tomsk' },
        { key: 51, label: 'Тула', alias: 'tula' },
        { key: 52, label: 'Тюмень', alias: 'tyumen' },
        { key: 53, label: 'Улан-Удэ', alias: 'ulan_ude' },
        { key: 54, label: 'Ульяновск', alias: 'ulyanovsk' },
        { key: 55, label: 'Уфа', alias: 'ufa' },
        { key: 56, label: 'Фрязино', alias: 'fryazino' },
        { key: 57, label: 'Хабаровск', alias: 'khabarovsk' },
        { key: 58, label: 'Чебоксары', alias: 'cheboksary' },
        { key: 59, label: 'Челябинск', alias: 'chelyabinsk' },
        { key: 60, label: 'Череповец', alias: 'cherepovets' },
        { key: 61, label: 'Чита', alias: 'chita' },
        { key: 62, label: 'Химки', alias: 'khimki' },
        { key: 63, label: 'Ярославль', alias: 'yaroslavl' },
        { key: 64, label: 'Новосибирск', alias: 'novosibirsk' },
    ],
    popular: [
        { key: 28, label: 'Москва', alias: 'moscow' },
        { key: 39, label: 'Санкт-Петербург', alias: 'sankt_peterburg' },
        { key: 64, label: 'Новосибирск', alias: 'novosibirsk' },
        { key: 13, label: 'Екатеринбург', alias: 'yekaterinburg' },
        { key: 16, label: 'Казань', alias: 'kazan' },
    ],
};

const ModalLocationForm = ({ callback_open, callback_close }: IModalProps) => {
    const [form] = Form.useForm();
    const [cities, setCities] = useState<any>();
    const [sortedCities, setSortedCities] = useState<any>();
    const [selectedCity, setSelectedCity] = useState<any>(null);
    const LOCALIZATION = useLocalization();
    const callback_submit = (values: any) => {
        console.log('result => ', values);
    };

    useEffect(() => {
        setCities(citiesList);

        return;
        // fetch(`${process.env.NEXT_PUBLIC_DOMAIN_BFF}/trade/diary/country`, {
        //     method: 'GET'
        // })
        //     .then(response => {
        //         if (response.status !== 200) {
        //             if (typeof window !== 'undefined') message.error(`Ошибка /trade/diary/country`)
        //             return undefined
        //         }
        //         return response
        //     })
        //     .then(response => {
        //         if (response) return response.json()
        //         return null
        //     })
        //     .then(response => {
        //
        //     })
        //     .catch(error => {
        //         console.log(error)
        //     })
    }, []);

    useEffect(() => {
        if (cities) {
            const groupedCities = cities.all
                ?.reduce((acc: any[], city: { label: string }) => {
                    const firstChar = city.label.charAt(0);
                    let group = acc.find((item) => item.char === firstChar);

                    if (!group) {
                        group = { char: firstChar, results: [] };
                        acc.push(group);
                    }
                    group.results.push(city);

                    return acc;
                }, [])
                .sort((a: { char: string }, b: { char: any }) => a?.char?.localeCompare(b.char));

            let currentColumnCount = 0;
            const columnSize = Math.ceil(cities.all.length / LOCATION_COLUMNS);
            const result = [[], [], [], []];
            let currentColumn: any[] = [];
            let currentIndex = 0;

            groupedCities.forEach((char: { results: string | any[] }) => {
                if (
                    currentColumnCount < columnSize &&
                    currentColumnCount + char.results.length <= columnSize
                ) {
                    currentColumn.push(char);
                    currentColumnCount += char.results.length;
                } else {
                    // @ts-ignore
                    result[currentIndex] = currentColumn;
                    currentColumnCount = 0;
                    currentColumn = [];
                    currentIndex += 1;
                    currentColumn.push(char);
                    currentColumnCount += char.results.length;
                }
            });
            setSortedCities(result);
        }
    }, [cities]);

    return (
        <Modal
            className={`${theme.GeneralContainer__Theme} ${mcc.modal}`}
            centered
            open={callback_open}
            onCancel={callback_close}
            width={1064}
            okButtonProps={{
                style: { margin: 0 },
                size: 'large',
                type: 'default',
                htmlType: 'submit',
                disabled: true,
            }}
            cancelButtonProps={{
                size: 'large',
                type: 'primary',
            }}
            okText={LOCALIZATION.modals.location.okText}
            cancelText={LOCALIZATION.modals.location.cancelText}
        >
            <Flex
                vertical
                className={mcc.location_container}
            >
                <Typography.Text className={`text-32-500`}>
                    {LOCALIZATION.modals.location.chooseYourCity}
                </Typography.Text>
                <Flex className={mcc.location_container__result}>
                    <Typography.Text className={`text-16-500`}>
                        {LOCALIZATION.modals.location.yourRegion}
                        {selectedCity?.label ?? LOCALIZATION.modals.location.notSpecified}
                    </Typography.Text>
                </Flex>
                <Input />
                <Flex className={mcc.location_container__popularCities}>
                    {cities?.popular?.map((city: any, i: number) => (
                        <Button
                            key={i}
                            className={`text-20-500 ${mcc.popularCities__city}`}
                            type={'text'}
                            onClick={() => {
                                setSelectedCity(city);
                            }}
                        >
                            {city.label}
                        </Button>
                    ))}
                </Flex>
                <Flex className={mcc.location_container__citiesList}>
                    {sortedCities?.map((column: any[], i: number) => (
                        <Flex
                            key={i}
                            vertical
                            className={mcc.citiesList__column}
                        >
                            {column?.map((char: any, j: number) => (
                                <Flex
                                    key={j}
                                    className={mcc.citiesList__column__item}
                                >
                                    <Typography.Text
                                        className={`text-16-500 ${mcc.column__item__letter}`}
                                    >
                                        {char.char}
                                    </Typography.Text>
                                    <Flex
                                        vertical
                                        className={mcc.column__item__citiesList}
                                    >
                                        {char?.results?.map((city: any, k: number) => (
                                            <Button
                                                key={k}
                                                className={`text-16-500`}
                                                type={'text'}
                                                onClick={() => {
                                                    setSelectedCity(city);
                                                }}
                                            >
                                                {city.label}
                                            </Button>
                                        ))}
                                    </Flex>
                                </Flex>
                            ))}
                        </Flex>
                    ))}
                </Flex>
                {/*<Layout className={mcc.location_container__citiesList}>*/}
                {/*    {sortedCities?.map((char: any) => (*/}
                {/*        <Flex className={mcc.citiesList__item}>*/}
                {/*            <Typography.Text>{char.char}</Typography.Text>*/}
                {/*            <Flex vertical>*/}
                {/*                {char?.results?.map((city: any) => (*/}
                {/*                    <Button onClick={() => {*/}
                {/*                        setSelectedCity(city)*/}
                {/*                    }}>{city.label}</Button>*/}
                {/*                ))}*/}
                {/*            </Flex>*/}
                {/*        </Flex>*/}
                {/*    ))}*/}
                {/*</Layout>*/}
            </Flex>
        </Modal>
    );
};

export default ModalLocationForm;
